import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedAuthAuthorizationModule } from '@portal/shared/auth/authorization';
import { PipesModule } from '@portal/shared/pipes';
// import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { AppScreenCarouselComponent } from './app-screen-carousel.component';
import Swiper from 'swiper';

@NgModule({
  imports: [CommonModule, SharedAuthAuthorizationModule, PipesModule],
  declarations: [AppScreenCarouselComponent],
  exports: [AppScreenCarouselComponent],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppScreenCarouselModule {}
